// src/App.js — the signed-in application: the auth gate around the app shell.
// Every signed-in route renders inside this as a child route (see AppRoutes).
import React from 'react';
import AuthGate from './components/shell/AuthGate';
import AppShell from './components/shell/AppShell';

const App = () => (
    <AuthGate>
        <AppShell />
    </AuthGate>
);

export default App;
